import { Hash, MapPin } from "lucide-react";

function PillRow({ items, active, onChange, testIdPrefix }) {
  return (
    <div className="flex gap-1.5 overflow-x-auto pb-1.5 -mx-3 px-3 sm:mx-0 sm:px-0 scrollbar-thin">
      {items.map((c) => {
        const isActive = c.id === active;
        return (
          <button
            key={c.id}
            onClick={() => onChange(c.id)}
            data-testid={`${testIdPrefix}-${c.id}`}
            className={`shrink-0 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap transition-all duration-200 active:scale-95 ${
              isActive
                ? "bg-[#1D5BFF] text-white shadow-[0_0_24px_rgba(0,102,255,0.45)]"
                : "bg-[#FFFFFF] text-slate-700 border border-slate-200 hover:border-slate-300 hover:text-slate-900"
            }`}
          >
            #{c.name}
          </button>
        );
      })}
    </div>
  );
}

export default function ChannelTabs({ channels, active, onChange }) {
  // Backwards compat: if channels have no `group`, treat as one row
  const themen = channels.filter((c) => !c.group || c.group === "Themen");
  const regionen = channels.filter((c) => c.group === "Regionen");

  return (
    <div className="space-y-2" data-testid="channel-tabs">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-[#4DBFFF]/80 mt-1">
        <Hash className="w-3 h-3" /> Themen
      </div>
      <PillRow items={themen} active={active} onChange={onChange} testIdPrefix="channel-pill" />
      {regionen.length > 0 && (
        <>
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-emerald-400/80 mt-1">
            <MapPin className="w-3 h-3" /> Regionen
          </div>
          <PillRow items={regionen} active={active} onChange={onChange} testIdPrefix="channel-pill" />
        </>
      )}
    </div>
  );
}
